import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import { GeneralPostingOptions, PostingTemplate } from '@professocial/professocialTypes/types/commonTypes'

import VideoPhoto from '../../../icons/VideoPhoto'
import { PostingScreen } from '../../../types/types'
import { getGeneralPostingOptions, getTheme } from '../../../../store/common/common.selectors'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    textTransform: 'inherit',
    marginRight: '30px',
  },
  icon: {
    verticalAlign: 'top',
  },
}))

interface IProps {
  posting: PostingTemplate
  changePosting?: (post: PostingTemplate) => void
  changePostingScreen?: (screen: PostingScreen) => void
}

const SelectImageVideo: React.FC<IProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const generalPostingOptions: GeneralPostingOptions = useSelector(getGeneralPostingOptions)
  const theme = useSelector(getTheme)
  return (
    <>
      <ButtonComponent
        variant='text'
        color='info'
        className={classes.root}
        text={
          <>
            <span style={{ paddingRight: '10px' }}>
              <VideoPhoto className={classes.icon} color={theme.palette.primary.main} width='25px' />
            </span>
            {generalPostingOptions.allowVideoUpload ? t('postingCommon:videoImage') : t('postingCommon:image')}
          </>
        }
        onClick={() => props.changePostingScreen && props.changePostingScreen(PostingScreen.MEDIA)}
      />
    </>
  )
}

export default SelectImageVideo
